import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

import { CHARTS } from '../utils/constants';
import { ChartFilters } from 'models/request';
import { ChartData } from 'models/response';

/**
 * This API return all or filtered array of charts
 * @param {body} body filters
 * @return {Promise<AxiosResponse<ChartData>>}
 */
const getCharts = (body: ChartFilters) =>
  trackPromise(axios.post<ChartData[]>(`${CHARTS}/multipleCharts`, body), 'module');

export default {
  getCharts,
};
